import React from 'react';
import classNames from 'classnames';
import { DrawerChildrenType } from '../types';
import styles from './DrawerLevel.module.scss';

export interface DrawerLevelProps {
	children: DrawerChildrenType;
	className?: string;
	isActive?: boolean;
	isUnstyled?: boolean;
	zIndex?: number;
}

/**
 * Generic DrawerLevel component, used for displaying content within a level of the Drawer
 * */
export const DrawerLevel: React.FunctionComponent<DrawerLevelProps> = ({
	className,
	children,
	isActive,
	isUnstyled,
	zIndex,
}) => {
	return (
		<section
			className={classNames(
				styles.wrapper,
				{ [styles.isActive]: isActive, [styles.isUnstyled]: isUnstyled },
				className,
			)}
			style={{ '--z-index': zIndex || 1 } as React.CSSProperties}
		>
			{children}
		</section>
	);
};
